import { render, staticRenderFns } from "./KurccFAB.vue?vue&type=template&id=7e8d57b7&scoped=true&"
import script from "./KurccFAB.vue?vue&type=script&lang=js&"
export * from "./KurccFAB.vue?vue&type=script&lang=js&"
import style0 from "./KurccFAB.vue?vue&type=style&index=0&id=7e8d57b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d57b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFabTransition,VIcon})
